import { portalPaths } from '@provision/portal-routes';

/**
 * Partner-prefixed like every other in-app URL. Unprefixed, the route gate reports ready before
 * a partner is selected, and selecting one then remounts the whole tree behind a spinner — so
 * the tab would paint the page, drop back to the spinner, and paint it again.
 *
 * The brand id tells the tab which preview to read; it is an opaque id, not page content.
 */
export function buildLandingPagePreviewUrl(
  partnerPrefix?: string | null,
  brandId?: string | null,
): string {
  const path = portalPaths.landingPagePreview();
  const prefix = partnerPrefix?.replace(/^\/+|\/+$/g, '');
  const url = prefix ? `/${prefix}${path}` : path;

  return brandId ? `${url}?brand=${encodeURIComponent(brandId)}` : url;
}
